import { Component, Input, ChangeDetectionStrategy } from '@angular/core'
import { SearchParams } from '@models/search/search-params'
import { storageKeys } from '@constants/storage-keys'
import { Router } from '@angular/router'
import { UsedFilter } from '@models/search/used-filter'
import { NgClass } from '@angular/common'
import { FocusRemoverDirective } from '../../directives/focus-remover.directive'
import { TranslatePipe } from '@ngx-translate/core'

@Component({
  selector: 'app-taglist',
  templateUrl: './taglist.component.html',
  styleUrls: ['./taglist.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [NgClass, FocusRemoverDirective, TranslatePipe]
})
export class TaglistComponent {
  @Input() tags: any[]
  @Input() elementId: string
  @Input() title: string
  @Input() card?: boolean
  @Input() hiddenTagsAmount?: number
  @Input() property?: string
  @Input() searchProperty?: string
  @Input() filterType?: string
  @Input() suitsAll?: boolean

  private from = 0
  private resultsPerPage = 15

  constructor(private router: Router) {}

  search(key: string, value: string): void {
    const searchParams: SearchParams = {
      keywords: null,
      filters: {
        [this.filterType]: [key]
      },
      from: this.from,
      size: this.resultsPerPage
    }
    const usedFilters: UsedFilter[] = [
      {
        key: key,
        value: value,
        type: this.filterType
      }
    ]
    sessionStorage.setItem(storageKeys.searchParams, JSON.stringify(searchParams))
    sessionStorage.setItem(storageKeys.usedFilters, JSON.stringify(usedFilters))

    void this.router.navigate(['/haku'])
  }
}
